<script>
  import "carbon-components-svelte/css/g90.css";
  import {Motion, M} from 'svelte-motion'
  import Tailwind from "../Tailwind.svelte";
  import {getLegal} from "../userdata"
  import { onMount } from "svelte";

  import {container, itemA, itemB, itemC} from '../components/animations.js'

  let legalData

  onMount(() => {
    legalData = getLegal()
  })


</script>
<Tailwind/>


    <div class="py-8 px-48 leading-8 font-rown">

      {#if legalData}
      {#await legalData}
      <p>please wait... </p>
      {:then legal}
        {@html legal.terms}
      {:catch error}
        <p>{error}</p>
        {/await}
      {/if}
    </div>
